module.exports = __webpack_public_path__ + "c46f6d8dffa48048b62c921057da5180.png";